<div class="overlay">
    <div class="loader">
      <div class="spinner-container">
        <img src="../../../../assets/logo.png" alt="logo">
        <div class="spinner"></div>
      </div>
    </div>
  </div>